var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBrnMapHelpLocationNew(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "46px",
    height: "32px",
    viewBox: "0 0 46 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "BRN---Mapping-the-Network---Instructions",
    transform: "translate(-484.000000, -499.000000)",
    fill: "#FFFFFF",
    stroke: "#E42610",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(486.000000, 501.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.9249664,2.94163516 C19.463918,0.169025964 37.6275924,-3.8006982 41.3851812,8.01719788 C44.5824513,18.0728502 34.9392508,25.675811 21.0556062,27.5529448 C-6.79593181,31.3186032 -4.35055359,10.2667032 12.9249664,2.94163516 Z",
    id: "Path-3-Copy-2",
    transform: "translate(21.000000, 14.000000) scale(1, -1) translate(-21.000000, -14.000000) "
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrnMapHelpLocationNew);
export default __webpack_public_path__ + "static/media/BRN-Map-Help-Location-NEW.812e8afec0ed88fa80cd7fff92e8f57d.svg";
export { ForwardRef as ReactComponent };